export const environment = {
  production: false,
  landingThemePreview: true,
  API_BASE_PUBLIC_URL: 'https://tolimpiada.uzedu.uz/api/',
  API_BASE_ADMIN_URL: 'https://tolimpadm.uzedu.uz/api/admins/',
  API_BASE_CLIENT_URL: 'https://tolimpiada.uzedu.uz/api/users/',
  type: 'user_cabinet',
  cacheVersion: '2026-09-09',
  allowProfilePhotoChange: true,
  allowApplicantPhotoChange: true,
};
